import {ChangeDetectionStrategy, Component, HostBinding, inject} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {Button, ButtonDirective, ButtonIcon} from "primeng/button";
import {RouterLink} from "@angular/router";
import {AnalyticsService} from "../../../services/analytics.service";
import {ExternalCodeService} from "../../../services/external-code.service";
import {environment} from "../../../../../environments/environment";
import {ShareService} from "../../../services/share.service";

@Component({
  selector: 'homey-header-buttons',
  imports: [
    Button,
    ButtonDirective,
    ButtonIcon,
    RouterLink
  ],
  templateUrl: './header-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderButtonsComponent {
  @HostBinding('class') readonly hostClass = 'h-full flex flex-row gap-2 items-center';
  private readonly userService = inject(UserService);
  private readonly externalCodeService = inject(ExternalCodeService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly shareService = inject(ShareService);
  protected readonly user = this.userService.user;

  private shareData = {
    url: 'https://www.myhomey.io?utm_campain=hshare',
    title: 'Homey NYC'
  };

  protected canShare = this.shareService.canShare(
    this.shareData
  )

  public onShareClick() {
    this.analyticsService.sendEvent('homey-share');
    this.shareService.share(this.shareData);
  }

  protected readonly environment = environment;
}
